import { REQUEST } from '~/middleware/ndsRequest';
import moment from '~/_moment';

const requestData = (options) => ({
  [REQUEST]: options,
});

export const StorageActionTypes = {
  LOAD_WATER_STORAGE: 'loadWaterStorage',
};

export default {
  getWaterStorage: (year = moment().format('Y')) => (dispatch) => {
    const options = {
      type: StorageActionTypes.LOAD_WATER_STORAGE,
      endpoint: `/rest/pressure/water-storage?year=${year}`,
      method: 'GET',
    };

    return dispatch(requestData(options));
  },
};



// WEBPACK FOOTER //
// ./resources/assets/js/actions/waterStorage.js